/**
 * @license
 * Copyright 2024 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
import { entryIdFromEventId, eventsAsHarnessRunResults, pathFromId, } from "./conversions.js";
/**
 * Meant to be a very lightweight wrapper around the
 * data in the `PathRegistryEntry`.
 */
export class NestedRun {
    dataStoreKey = Date.now().toFixed(3);
    #entry;
    mainGraphId;
    start;
    end;
    graphVersion = 0;
    events;
    edges = [];
    constructor(entry) {
        this.mainGraphId = entry.mainGraphId;
        this.start = entry.graphStart;
        this.end = entry.graphEnd;
        this.events = entry.events;
        this.#entry = entry;
    }
    currentNodeEvent() {
        return null;
    }
    stack() {
        // TODO: Implement stack support for nested runs.
        return [];
    }
    getEventById(id) {
        const entryId = entryIdFromEventId(id);
        if (!entryId)
            return null;
        const path = pathFromId(entryId);
        const entry = this.#entry.find(path);
        return entry?.event || null;
    }
    inputs() {
        return null;
    }
    async *replay() {
        const { view } = this.#entry;
        if (!view) {
            return;
        }
        const { sequence, start } = view;
        if (!sequence) {
            return;
        }
        const timeline = sequence.slice(start);
        yield* eventsAsHarnessRunResults(timeline);
    }
}
//# sourceMappingURL=nested-run.js.map